import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import IconTrash from "../iconComponents/IconTrash";
import DocStatusTag from "../common/DocStatusTag";
import {numberWithCommas, getRoleName } from "../common/Helpers";


export function WorkflowListItem(props) {

// const item = useSelector(state => state.item);
const contract = props.contract;

const [rowIsHovered, setRowIsHovered] = useState(null);
const [trashIsHovered, setTrashIsHovered] = useState(null);




const mode = contract.contract_name !== null ? ( contract.contract_status !== "Draft" ? "view" : "editparties" ) : "editdetails";
// A Basic-tier company is always exactly one person -- show that person directly
// rather than a company name that doesn't represent a real organization.
const vendorName = contract.company_vendor_is_basic
    ? (contract.vendor_person_name || contract.vendor_person_email)
    : (contract.company_vendor_name ? contract.company_vendor_name : (contract.contract_status === "Draft" ? "-" : "New User"))
const purchaserName = contract.company_purchaser_is_basic
    ? (contract.purchaser_person_name || contract.purchaser_person_email)
    : (contract.company_purchaser_name ? contract.company_purchaser_name : (contract.contract_status === "Draft" ? "-" : "New Purchaser"))
// const statusColor =  contract.contract_status === "Active" ? "#25A560" : ( contract.is_rejected ? "#c52a00" : "#BBBAC0");
const roles = contract.contract_user_roles ? contract.contract_user_roles : []; 

const workflowName = ((!contract.contract_name || contract.name?.length === 0) && contract.contract_status === "Draft") ? "Untitled Draft" : contract.contract_name;

// const rowColor = contract.role_id ? "p9" : "";
// const rowHoverColor = contract.role_id ? "p8c" : "g9";
const background = rowIsHovered ? "g9" : "";

    return (
        <tr 
            key={contract.contract_id} 
            className={`table-row ${background}`}
            onMouseEnter={() => setRowIsHovered(true)}
            onMouseLeave={() => setRowIsHovered(false)}
        >
            {/* Contract */}    
            {/* <td className={`typical rigid content1 ${color} first hidedec`}  
                style={{paddingRight: "4px"}}
                onClick={(e) => props.handleSelectWfItem(e)} 
                to-mode={mode}
                to-id={contract.contract_id} >
                <IconContract height="18px" pathClass={contract.contract_status === "Draft" ? "g7-fill" : "g2-fill"}  className="td-icon"/>
            </td> */}
            <td className={`typical flexi content1 multiline light-black name `} 
                style={{width: "17%"}} 
                onClick={(e) => props.handleSelectWfItem(e)} 
                to-mode={mode}
                to-id={contract.contract_id} > 
                <span className={"heavy"}>{workflowName}</span>
                <br></br>
                {contract.contract_number && '# ' + contract.contract_number }
            </td>
            {/* Project */}
            <td className={`typical flexi content1 light-black `} 
                style={{width: "17%"}} 
                onClick={(e) => props.handleSelectWfItem(e)} 
                to-mode={mode}
                to-id={contract.contract_id} >
                {contract.project_name}
            </td>

            {/* Purchaser / Vendor */}
            <td className={`typical flexi content1 light-black `} 
                style={{width: "17%"}} 
                onClick={(e) => props.handleSelectWfItem(e)} 
                to-mode={mode}
                to-id={contract.contract_id} >
                <div style={{lineHeight: "150%"}}>
                    {/* {contract.company_purchaser_icon_path && <img className="gap-right-s list-logo iblock" src={contract.company_purchaser_icon_path}  role="presentation" />} */}
                    <span className="heavy-grey">{props.sortByCompany === "Purchaser" ? "P" : "V"}&nbsp;&nbsp;&nbsp;</span>
                    {props.sortByCompany === "Purchaser" ? purchaserName : vendorName}
                </div>
                <div style={{lineHeight: "150%"}}>
                    <span className="heavy-grey">{props.sortByCompany === "Purchaser" ? "V" : "P"}&nbsp;&nbsp;&nbsp;</span>
                    {/* {contract.company_vendor_icon_path && <img className="gap-right-s list-logo iblock" src={contract.company_vendor_icon_path}  role="presentation" />} */}
                    {props.sortByCompany === "Purchaser" ? vendorName : purchaserName}
                </div>
            </td>
            <td className={`typical flexi content1 light-black `} 
                style={{width: "17%"}} 
                onClick={(e) => props.handleSelectWfItem(e)} 
                to-mode={mode}
                to-id={contract.contract_id} >
                {roles.map((role, index) => {
                    return <span key={index} >{getRoleName(role)}{index !== contract.contract_user_roles.length - 1 ? ", " : ""}</span>
                })}
            </td>
            {/* Status */}
            <td className={`typical last-cell rigid content1 light-black `} 
                onClick={(e) => props.handleSelectWfItem(e)} 
                to-mode={mode}
                to-id={contract.contract_id} >
                <DocStatusTag status={contract.is_rejected ? "Rejected" : contract.contract_status} fontSize="content3" >
                    {contract.is_rejected ? "Rejected" : contract.contract_status}
                </DocStatusTag>
            </td>
        </tr> 
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(WorkflowListItem);